import React from "react";
import InputWithIcon from "../FormFields/InputWithIcon";
import { icons } from "../../assets/icons";
import CustomButton from "../CustomButton";
import { Form, Formik } from "formik";
import { profileValidation } from "../../utils/validations/profile";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext";
import ProfilePic from '../../assets/images/profile1.png'

const Profile = ({ profileData = {} }) => {
  const { apiCall } = useApi();
  const { name, email, mobile } = profileData;
  const { setUser, user } = useAuth();

  const onSubmitProfile = (values) => {
    apiCall({
      url: apiUrls.user.profile,
      dataToSend: values,
      onSuccess: (data = {}) => {
        toast.success("Profile updated successfully");
        setUser({ ...user, ...data });
      },
      method: "put",
    });
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={profileValidation}
      initialValues={{ name, mobile, email }}
      onSubmit={onSubmitProfile}
    >
      {({ errors, touched, values, setFieldValue }) => {
        return (
          <Form>
            <div className="flex flex-col gap-y-4 py-8">
              <div className="flex justify-between pb-2">
                <div className="font-size-small text-[var(--blackColor)] w-[13rem]">
                  Profile Photo
                </div>
                <div className="w-[10rem] h-[10rem] relative">
                  <img
                    // src="https://picsum.photos/200/300"
                    src={ProfilePic}
                    alt="user profile"
                    className="w-[100%] h-[100%] rounded-[0.6rem]"
                  />
                  <div className="cursor-pointer absolute bottom-0 right-0 bg-[var(--whiteColor)] pr-[0.3rem] pl-[0.6rem] py-[0.5rem] flex items-center justify-center rounded-tl-[0.8rem]">
                    <img
                      src={icons.editPhotoIcon}
                      alt="edit profile pic"
                      className="w-[2.2rem] h-[2.1rem]"
                    />
                  </div>
                </div>
              </div>

              <InputWithIcon
                title="Full Name"
                containerClassName="!min-h-[4rem] "
                value={values?.name}
                onChange={(e) => {
                  setFieldValue("name", e);
                }}
                error={touched.name && errors.name}
              />

              <InputWithIcon
                title="Designation"
                value={user?.userLabel}
                containerClassName="!min-h-[4rem] "
                disabled
              />

              <InputWithIcon
                title="Country/Region"
                value="India/NCR"
                containerClassName="!min-h-[4rem] "
                disabled
              />

              <div className="flex flex-col gap-y-4">
                <InputWithIcon
                  title="Email Address"
                  inputClassName=""
                  value={values?.email}
                  disabled
                  containerClassName="!min-h-[4rem]"
                />
                <div className="flex items-center gap-x-2 cursor-pointer">
                  <img
                    src={icons.circlePlusIcon}
                    alt="circle plus"
                    className="w-[2.4rem] h-[2.4rem]"
                  />
                  <div className="font-size-small text-[var(--textRed)] underline">
                    Add Email Address
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-y-4">
                <InputWithIcon
                  title="Mobile Number"
                  value={values?.mobile}
                  containerClassName="!w-[31rem] !min-h-[4rem]"
                  onChange={(e) => {
                    setFieldValue("mobile", e);
                  }}
                  error={touched.mobile && errors.mobile}
                />
                <div className="flex items-center gap-x-2 cursor-pointer">
                  <img
                    src={icons.circlePlusIcon}
                    alt="circle plus"
                    className="w-[2.4rem] h-[2.4rem]"
                  />
                  <div className="font-size-small text-[var(--textRed)] underline">
                    Add Number
                  </div>
                </div>
              </div>
              <CustomButton
                title="Save Profile"
                wrapperClassName="!px-10 mt-10 !w-[100%]"
                type="submit"
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default Profile;
